











 








const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GitHubScopingSearchFilterMenuRoot_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "PokerMeeting",
  "abstractKey": null
};

(node ).hash = "1aa4fe05f5f3c702d2125ce72a4ed552";

export default node;
